import React from 'react';
import { CalendarIcon, MapPinIcon, DollarSignIcon, TrophyIcon, AlertCircleIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      {/* Hero Section */}
      <header className="w-full bg-gradient-to-b from-gray-900 to-gray-800 py-16 px-4" data-id="element-1">
        <div className="max-w-6xl mx-auto text-center" data-id="element-2">
          <h1 className="text-5xl md:text-7xl font-black mb-4 tracking-tight text-white" data-id="element-3">
            FLSC
          </h1>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-4">
            Police Pistol Combat Match
          </h2>
          <div className="text-2xl md:text-3xl font-semibold mb-4 text-white" data-id="element-5">
            March 12-15, 2026
          </div>
          <div className="text-lg md:text-xl italic mb-2" style={{
          color: '#D1D5DB'
        }} data-id="element-6">
            Registration ends at 3:00PM Sunday
          </div>
          <div className="text-xl md:text-2xl font-bold mb-2" style={{
          color: '#FCD34D'
        }} data-id="element-7">
            Banquet 5:30PM, March 15
          </div>
          <div className="text-base" style={{
          color: '#D1D5DB'
        }} data-id="element-8">
            Meal Ticket Required - Extra tickets $10.00
          </div>
        </div>
      </header>

      {/* Location & Schedule */}
      <section className="w-full py-16 px-4 bg-gray-50" data-id="element-9">
        <div className="max-w-6xl mx-auto" data-id="element-10">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-11">
            {/* Location */}
            <div data-id="element-12">
              <div className="flex items-center gap-3 mb-6" data-id="element-13">
                <MapPinIcon className="w-8 h-8 text-yellow-500" data-id="element-14" />
                <h3 className="text-3xl font-bold text-gray-900" data-id="element-15">Location</h3>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-yellow-400" data-id="element-16">
                <div className="text-xl font-bold text-gray-900 mb-2" data-id="element-17">FLSC</div>
                <div className="text-lg text-gray-700" data-id="element-18">1140 Butcher Rd</div>
                <div className="text-lg text-gray-700" data-id="element-19">Fenton, MI 48430</div>
              </div>
            </div>

            {/* Schedule */}
            <div data-id="element-20">
              <div className="flex items-center gap-3 mb-6" data-id="element-21">
                <CalendarIcon className="w-8 h-8 text-yellow-500" data-id="element-22" />
                <h3 className="text-3xl font-bold text-gray-900" data-id="element-23">Schedule</h3>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm space-y-3" data-id="element-24">
                <div className="flex justify-between items-center pb-3 border-b border-gray-200" data-id="element-25">
                  <span className="font-semibold text-gray-900" data-id="element-26">
                    Thurs Mar 12
                  </span>
                  <span className="text-gray-700" data-id="element-27">5:00 PM - 9:00 PM</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-200" data-id="element-28">
                  <span className="font-semibold text-gray-900" data-id="element-29">
                    Fri Mar 13
                  </span>
                  <span className="text-gray-700" data-id="element-30">5:00 PM - 9:00 PM</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-200" data-id="element-31">
                  <span className="font-semibold text-gray-900" data-id="element-32">
                    Sat Mar 15
                  </span>
                  <span className="text-gray-700" data-id="element-33">9:00 AM - 5:00 PM</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-34">
                  <span className="font-semibold text-gray-900" data-id="element-35">
                    Sun Mar 15
                  </span>
                  <span className="text-gray-700 font-bold" data-id="element-36">
                    9:00 AM - 3:00 PM
                  </span>
                </div>
                <div className="pt-3 text-sm text-gray-600 italic" data-id="element-37">
                  Refreshments available until 1:00PM Sunday
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Match Information */}
      <section className="w-full py-16 px-4 bg-white" data-id="element-38">
        <div className="max-w-6xl mx-auto" data-id="element-39">
          <div className="flex items-center gap-3 mb-8" data-id="element-40">
            <DollarSignIcon className="w-8 h-8 text-yellow-500" data-id="element-41" />
            <h3 className="text-3xl font-bold text-gray-900" data-id="element-42">
              Match Information
            </h3>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-43">
            {/* Pricing */}
            <div className="bg-yellow-50 p-8 rounded-lg border-2 border-yellow-400" data-id="element-44">
              <h4 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-45">Cost</h4>
              <div className="space-y-2 text-lg" data-id="element-46">
                <div className="flex justify-between items-center" data-id="element-47">
                  <span className="font-semibold" data-id="element-48">PPC Match:</span>
                  <span className="text-2xl font-bold text-gray-900" data-id="element-49">$60</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-50">
                  <span className="font-semibold" data-id="element-51">Service Match:</span>
                  <span className="text-2xl font-bold text-gray-900" data-id="element-52">$30</span>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-yellow-300 text-sm text-gray-700" data-id="element-53">
                Both Combat and Service are 60 round matches
              </div>
            </div>

            {/* Key Details */}
            <div className="bg-gray-50 p-8 rounded-lg" data-id="element-54">
              <h4 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-55">
                Key Details
              </h4>
              <ul className="space-y-3 text-gray-700" data-id="element-56">
                <li className="flex items-start gap-2" data-id="element-57">
                  <span className="text-yellow-500 font-bold" data-id="element-58">•</span>
                  <span data-id="element-59">
                    Service Match only available to PPC Shooters (Must skip at
                    least one line between scores)
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-60">
                  <span className="text-yellow-500 font-bold" data-id="element-61">•</span>
                  <span data-id="element-62">Red dot sights allowed. No lasers</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-63">
                  <span className="text-yellow-500 font-bold" data-id="element-64">•</span>
                  <span data-id="element-65">
                    Open to all shooters 18 and older who are familiar with PPC
                    course of fire
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-66">
                  <span className="text-yellow-500 font-bold" data-id="element-67">•</span>
                  <span data-id="element-68">
                    (under 18 requires Match Director approval and parent
                    present)
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-69">
                  <span className="text-yellow-500 font-bold" data-id="element-70">•</span>
                  <span data-id="element-71">50' indoor B27R targets will be used</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-72">
                  <span className="text-yellow-500 font-bold" data-id="element-73">•</span>
                  <span data-id="element-74">Scoring will be by staff (as available)</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-75">
                  <span className="text-yellow-500 font-bold" data-id="element-76">•</span>
                  <span data-id="element-77">B targets will be used as tie breaker</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-78">
                  <span className="text-yellow-500 font-bold" data-id="element-79">•</span>
                  <span data-id="element-80">$10.00 fee for protest challenges</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Additional Info */}
          <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500" data-id="element-81">
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-82">
              Bring a shotgun
            </h4>
            <p className="text-gray-700 mb-2" data-id="element-83">
              Registered match shooters can{' '}
              <span className="font-semibold" data-id="element-84">Shoot Sporting Clays</span>
            </p>
            <p className="text-gray-700 font-semibold" data-id="element-85">
              All weekend at member rates
            </p>
          </div>
        </div>
      </section>

      {/* Prizes Section */}
      <section className="w-full py-16 px-4 bg-gray-900" data-id="element-86">
        <div className="max-w-6xl mx-auto" data-id="element-87">
          <div className="flex items-center gap-3 mb-8" data-id="element-88">
            <TrophyIcon className="w-8 h-8" style={{
            color: '#FCD34D'
          }} data-id="element-89" />
            <h3 className="text-3xl font-bold text-white" data-id="element-90">Prizes</h3>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-91">
            {/* PPC Prizes */}
            <div className="bg-gray-800 p-8 rounded-lg border-2 border-yellow-400" data-id="element-92">
              <h4 className="text-2xl font-bold mb-6" style={{
              color: '#FCD34D'
            }} data-id="element-93">
                PPC
              </h4>
              <div className="space-y-4" data-id="element-94">
                <div className="pb-4 border-b border-gray-700" data-id="element-95">
                  <div className="font-bold mb-1" style={{
                  color: '#FCD34D'
                }} data-id="element-96">
                    1st PLACE
                  </div>
                  <div className="text-lg text-white" data-id="element-97">CANIK METE MC9LS 9MM</div>
                </div>
                <div className="pb-4 border-b border-gray-700" data-id="element-98">
                  <div className="font-bold mb-1" style={{
                  color: '#FCD34D'
                }} data-id="element-99">
                    2nd PLACE
                  </div>
                  <div className="text-lg text-white" data-id="element-100">
                    CANIK METE SF ONE SERIES 9MM
                  </div>
                </div>
                <div data-id="element-101">
                  <div className="font-bold mb-1" style={{
                  color: '#FCD34D'
                }} data-id="element-102">
                    3rd PLACE
                  </div>
                  <div className="text-lg text-white" data-id="element-103">
                    SUREFIRE STILETTO FLASHLIGHT
                  </div>
                </div>
              </div>
            </div>

            {/* Service Prizes */}
            <div className="bg-gray-800 p-8 rounded-lg border-2 border-blue-400" data-id="element-104">
              <h4 className="text-2xl font-bold mb-6" style={{
              color: '#60A5FA'
            }} data-id="element-105">
                SERVICE
              </h4>
              <div className="space-y-4" data-id="element-106">
                <div className="pb-4 border-b border-gray-700" data-id="element-107">
                  <div className="font-bold mb-1" style={{
                  color: '#60A5FA'
                }} data-id="element-108">
                    1st PLACE
                  </div>
                  <div className="text-lg text-white" data-id="element-109">CZ P 10F 9MM</div>
                </div>
                <div className="pb-4 border-b border-gray-700" data-id="element-110">
                  <div className="font-bold mb-1" style={{
                  color: '#60A5FA'
                }} data-id="element-111">
                    2nd PLACE
                  </div>
                  <div className="text-lg text-white" data-id="element-112">RUGER LCP MAX 380</div>
                </div>
                <div className="pb-4 border-b border-gray-700" data-id="element-113">
                  <div className="font-bold mb-1" style={{
                  color: '#60A5FA'
                }} data-id="element-114">
                    3rd PLACE
                  </div>
                  <div className="text-lg text-white" data-id="element-115">
                    STREAMLIGHT WEDGE XT FLASHLIGHT
                  </div>
                </div>
                <div className="pt-2" data-id="element-116">
                  <div className="text-lg font-bold" style={{
                  color: '#FCD34D'
                }} data-id="element-117">
                    3 GUN SWEEPSTAKES
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Prizes */}
          <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-gray-900 p-8 rounded-lg mb-8" data-id="element-118">
            <h4 className="text-2xl font-black mb-4" data-id="element-119">
              TICKETS AVAILABLE THROUGHOUT MATCH
            </h4>
            <p className="text-sm mb-4 font-semibold" data-id="element-120">
              (COMPETITORS AND STAFF ONLY)
            </p>
            <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-121">
              <div className="bg-white p-4 rounded" data-id="element-122">
                <div className="font-bold text-sm mb-1" data-id="element-123">1:</div>
                <div className="font-semibold" data-id="element-124">
                  SPRINGFIELD 1911 EMISSARY 9MM
                </div>
              </div>
              <div className="bg-white p-4 rounded" data-id="element-125">
                <div className="font-bold text-sm mb-1" data-id="element-126">2:</div>
                <div className="font-semibold" data-id="element-127">CANIK RIVAL SFX 9MM</div>
              </div>
              <div className="bg-white p-4 rounded" data-id="element-128">
                <div className="font-bold text-sm mb-1" data-id="element-129">3:</div>
                <div className="font-semibold" data-id="element-130">SMITH FPC 9MM</div>
              </div>
            </div>
            <div className="text-center" data-id="element-131">
              <div className="text-3xl font-black mb-2" data-id="element-132">2 CARD DECK GUNS</div>
              <div className="text-lg font-bold" data-id="element-133">
                TO BE ANNOUNCED AT BANQUET
              </div>
              <div className="text-sm mt-2 italic" data-id="element-134">
                (Note: 1 gun per shooter rule applies only to match prizes not
                sweepstakes)
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-135">
            <div className="text-4xl font-black mb-4" style={{
            color: '#FCD34D'
          }} data-id="element-136">
              LOTS OF DOOR PRIZES
            </div>
            <div className="bg-gray-800 p-6 rounded-lg inline-block" data-id="element-137">
              <div className="text-lg font-bold mb-2 text-white" data-id="element-138">
                CPL or Permit to Purchase
              </div>
              <div className="text-base text-white" data-id="element-139">
                Required for All Firearm Prizes
              </div>
              <div className="text-base text-white" data-id="element-140">
                All Prizes MUST be Picked up
              </div>
              <div className="text-base text-white" data-id="element-141">Within 30 Days or</div>
              <div className="text-base text-white" data-id="element-142">
                They Revert to the Property of FLSC
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Rules & Requirements */}
      <section className="w-full py-16 px-4 bg-red-50" data-id="element-143">
        <div className="max-w-6xl mx-auto" data-id="element-144">
          <div className="flex items-center gap-3 mb-8" data-id="element-145">
            <AlertCircleIcon className="w-8 h-8 text-red-600" data-id="element-146" />
            <h3 className="text-3xl font-bold text-gray-900" data-id="element-147">
              Rules & Requirements
            </h3>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-148">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-149">
              <h4 className="text-xl font-bold text-gray-900 mb-4" data-id="element-150">
                Safety Requirements
              </h4>
              <ul className="space-y-2 text-gray-700" data-id="element-151">
                <li className="flex items-start gap-2" data-id="element-152">
                  <span className="text-red-600 font-bold" data-id="element-153">•</span>
                  <span data-id="element-154">NRA Rules apply</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-155">
                  <span className="text-red-600 font-bold" data-id="element-156">•</span>
                  <span data-id="element-157">Eye and Ear protection are mandatory</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-158">
                  <span className="text-red-600 font-bold" data-id="element-159">•</span>
                  <span data-id="element-160">Minimum of 4 speed loaders or magazines</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-161">
                  <span className="text-red-600 font-bold" data-id="element-162">•</span>
                  <span data-id="element-163">Ammunition will be the responsibly of the shooter</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-164">
              <h4 className="text-xl font-bold text-gray-900 mb-4" data-id="element-165">
                Equipment Requirements
              </h4>
              <ul className="space-y-2 text-gray-700" data-id="element-166">
                <li className="flex items-start gap-2" data-id="element-167">
                  <span className="text-red-600 font-bold" data-id="element-168">•</span>
                  <span data-id="element-169">Minimum .38 caliber</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-170">
                  <span className="text-red-600 font-bold" data-id="element-171">•</span>
                  <span data-id="element-172">No High velocity or Magnum rounds allowed</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-173">
                  <span className="text-red-600 font-bold" data-id="element-174">•</span>
                  <span data-id="element-175">No cross draw or shoulder holsters allowed</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-176">
                  <span className="text-red-600 font-bold" data-id="element-177">•</span>
                  <span data-id="element-178">
                    Max 4" revolver or 5" semi-auto required for service match
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-179">
                  <span className="text-red-600 font-bold" data-id="element-180">•</span>
                  <span data-id="element-181">
                    Decisions of Match Director & Deputy Director are Final
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 bg-white p-6 rounded-lg shadow-sm" data-id="element-182">
            <h4 className="text-xl font-bold text-gray-900 mb-4" data-id="element-183">
              Attention Canadian Shooters
            </h4>
            <p className="text-gray-700" data-id="element-184">
              Gun award winners MUST have a US FFL or Michigan Permit to
              Purchase to take possession of a firearm award or prize. If an
              award winner can not meet this requirement, an offer of cash, the
              amount that FLSC paid for prize will be offered. Preference must
              be declared at time award is presented.
            </p>
          </div>

          <div className="mt-8 bg-red-900 text-white p-6 rounded-lg text-center" data-id="element-185">
            <div className="text-2xl font-black mb-2" data-id="element-186">
              NO Alcoholic Beverages or Gambling at Range
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="w-full py-16 px-4 bg-gray-900" data-id="element-187">
        <div className="max-w-4xl mx-auto text-center" data-id="element-188">
          <h3 className="text-3xl font-bold mb-8 text-white" data-id="element-189">
            For Further Information
          </h3>
          <div className="bg-gray-800 p-8 rounded-lg" data-id="element-190">
            <div className="text-xl font-bold mb-4 text-white" data-id="element-191">
              Contact Bill Hohloch
            </div>
            <div className="flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-192">
              <a href="tel:810-869-5136" className="flex items-center gap-2 hover:opacity-80 transition-opacity text-lg" style={{
              color: '#FCD34D'
            }} data-id="element-193">
                <PhoneIcon className="w-5 h-5" data-id="element-194" />
                <span data-id="element-195">810-869-5136</span>
              </a>
              <a href="mailto:k100bill@yahoo.com" className="flex items-center gap-2 hover:opacity-80 transition-opacity text-lg" style={{
              color: '#FCD34D'
            }} data-id="element-196">
                <MailIcon className="w-5 h-5" data-id="element-197" />
                <span data-id="element-198">k100bill@yahoo.com</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}